import { render, staticRenderFns } from "./ChooseCourse.vue?vue&type=template&id=70bb507e&scoped=true&"
import script from "./ChooseCourse.vue?vue&type=script&lang=js&"
export * from "./ChooseCourse.vue?vue&type=script&lang=js&"
import style0 from "./ChooseCourse.vue?vue&type=style&index=0&id=70bb507e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70bb507e",
  null
  
)

export default component.exports